import type { ReactElement } from 'react';

import { Divider } from '@xing-com/divider';

import * as Styled from './card-header-section.styled';
import type { CardHeaderSectionProps } from './card-header-section.types';

export type { CardHeaderSectionProps } from './card-header-section.types';

export const CardHeaderSection = ({
  children,
}: CardHeaderSectionProps): ReactElement => (
  <Styled.HeaderSection>
    <Styled.HeaderContentWrapper>{children}</Styled.HeaderContentWrapper>
    <Divider />
  </Styled.HeaderSection>
);
